import { useMemo } from "react";
import { Search, CloudSun, ScrollText, Truck } from "lucide-react";
import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

interface InputSuggestProps {
  onSendMessage?: (message: string) => void;
}

const suggestions: {
  label: string;
  icon: LucideIcon;
  iconColor: string;
}[] = [
  { label: "帮我找货", icon: Search, iconColor: "text-blue-500" },
  { label: "查询天气信息", icon: CloudSun, iconColor: "text-yellow-500" },
  { label: "相关政策", icon: ScrollText, iconColor: "text-green-500" },
  { label: "我的车辆", icon: Truck, iconColor: "text-orange-500" },
];

export function InputSuggest({ onSendMessage }: InputSuggestProps) {
  const displayedSuggestions = useMemo(() => {
    const shuffled = [...suggestions].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 3);
  }, []);

  return (
    <div className="w-full bg-white px-4 pt-3 pb-2 shadow-[0_-2px_10px_5px_#F7F7F7] rounded-t-[21px]">
      <div className="flex flex-wrap items-center gap-2">
        {displayedSuggestions.map(({ label, icon: Icon, iconColor }) => (
          <button
            key={label}
            type="button"
            onClick={() => onSendMessage?.(label)}
            className={cn(
              "inline-flex items-center gap-1.5",
              "rounded-full border border-slate-200 bg-slate-50",
              "px-3 py-1.5 text-sm text-slate-600",
              "hover:bg-white hover:border-slate-300 hover:text-slate-900",
              "transition-colors duration-150"
            )}
          >
            <Icon className={cn("h-3.5 w-3.5 shrink-0", iconColor)} />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
